(function() {
  window.RS = window.RS || {};
  window.RS.Utilities = window.RS.Utilities || {};

  /*
   * Moved functions to window object for quick add
   */
  window.RS.Utilities.variantChangeEvent = function variantChangeEvent() {
    //PRODUCT PAGE OPTION SELECT (LIST OPTIONS)
    var listOptions = document.querySelectorAll('.list-option');
    if (listOptions) {
      listOptions.forEach(function (listOption) {
        listOption.addEventListener('change', function () {
          listOptions.forEach(function (option) {
            option.removeAttribute('aria-selected');
          });
          listOption.setAttribute('aria-selected', 'true');

          window.RS.Utilities.getActiveVariant();
        });
      });
    }
  }

  // GET ACTIVE VARIANT BASED ON OPTIONS ABOVE
  window.RS.Utilities.getActiveVariant = function getActiveVariant(variantId = null, modal = false) {
    var event = new Event('change');
    let selectedOptions = document.querySelectorAll('.radio-select input[aria-selected="true"]');
    let productSelectedOption = document.querySelector('#ProductSelect option:checked');
    let productSelectBox = document.querySelector('#ProductSelect');
    let selectedOptionArray = [];
    let variantSelectedOption = '';
    let variantPrice = '';
    let variantCompareAtPrice = '';

    // Get the select option values for each option (max is 3)
    // This will be used on the next step when we use that data
    // to locate the exact variant.
    //
    // The data attribute of optionPosition comes from the liquid 
    // markup to help us know when or if we're capturing th next 
    // option value.
    selectedOptions.forEach(function (option) {
      let optionName = option.ariaLabel;
      let optionPosition = option.dataset.optionPosition;
      let finalObject = {
        'name': optionName,
        'optionPosition': optionPosition
      }
      selectedOptionArray.push(finalObject);
    });

    if (variantId) {
      variantSelectedOption = document.querySelector(`option[value='${variantId}']`)
    } else {
      // This is some fancy stuff. The idea is to use the array
      // above of all the option values. 
      if (selectedOptionArray.length == 1) {
        variantSelectedOption = document.querySelector('#ProductSelect option[data-option-' + selectedOptionArray[0].optionPosition + '="' + selectedOptionArray[0].name + '"]');
      } else if (selectedOptionArray.length == 2) {
        variantSelectedOption = document.querySelector('#ProductSelect option[data-option-' + selectedOptionArray[0].optionPosition + '="' + selectedOptionArray[0].name + '"][data-option-' + selectedOptionArray[1].optionPosition + '="' + selectedOptionArray[1].name + '"]');
      } else if (selectedOptionArray.length == 3) {
        variantSelectedOption = document.querySelector('#ProductSelect option[data-option-' + selectedOptionArray[0].optionPosition + '="' + selectedOptionArray[0].name + '"][data-option-' + selectedOptionArray[1].optionPosition + '="' + selectedOptionArray[1].name + '"][data-option-' + selectedOptionArray[2].optionPosition + '="' + selectedOptionArray[2].name + '"]');
      } else {}
    }

    // Deslect the current option
    productSelectedOption?.removeAttribute('selected')

    // Select the new variant. Update states across the board.
    if (variantSelectedOption) {
      let vID = variantSelectedOption.value
      let skuContainer = document.querySelector('.sku')
      variantSelectedOption.setAttribute('selected', true);
      variantSKU = variantSelectedOption.getAttribute('data-variant-sku');
      variantPrice = variantSelectedOption.getAttribute('data-price');
      variantCompareAtPrice = variantSelectedOption.getAttribute('data-compare-at-price');
      productSelectBox.dispatchEvent(event);
      window.RS.Utilities.updatePricing(variantPrice, variantCompareAtPrice);
      window.RS.Utilities.updateButton(variantSelectedOption, modal);
      skuContainer.innerHTML = "SKU: " + variantSKU;
      return vID;
    } else {
      return false;
    }
  }

  window.RS.Utilities.updatePricing = function updatePricing(price, compare_at_price) {
    let priceMount = document.querySelector('.product-single__price');
    let priceHTML = '';
    if (compare_at_price > price) {
      priceHTML += '<s id="ComparePrice">'
      priceHTML += '<span class="sr-only">Original price: </span>';
      priceHTML += compare_at_price
      priceHTML += '</s>';
      priceHTML += '<span class="product-price__price product-price__sale">';
      priceHTML += '<span id="ProductPrice" class="persimmon">';
      priceHTML += '<span class="sr-only">Current price: </span>';
      priceHTML += price
      priceHTML += '</span>';
      priceHTML += '</span>';
    } else {
      priceHTML += '<span>';
      priceHTML += '<s class="hide" id="ComparePrice">';
      priceHTML += '<span class="sr-only">Original price: </span>';
      priceHTML += compare_at_price
      priceHTML += '</s>';
      priceHTML += '<span class="product-price__price">';
      priceHTML += '<span id="ProductPrice">';
      priceHTML += '<span class="sr-only">Current price: </span>';
      priceHTML += price
      priceHTML += '</span>';
      priceHTML += '</span>';
      priceHTML += '</span>';
    }
    priceMount.innerHTML = priceHTML;
  }

  window.RS.Utilities.updateButton = function updateButton(variantSelectedOption, modal) {
    let button = document.querySelector('.js-add-to-cart');
    let allButtons = document.querySelectorAll('.js-add-to-cart');
    if(modal && allButtons.length > 0) {
      allButtons.forEach(function(button) {
        updateButtonText(variantSelectedOption, button)
      });
    } else if (button) {
      updateButtonText(variantSelectedOption, button)
    }
  }

  updateButtonText = function (variantSelectedOption, button) {
    let buttonText = button.querySelector('span');
    let soldOut = variantSelectedOption.getAttribute('disabled');
    if (soldOut) {
      button.removeAttribute('disabled');
      button.setAttribute('disabled', true);
      buttonText.innerHTML = "Sold out"
    } else {
      button.removeAttribute('disabled');
      buttonText.innerHTML = "Add to cart"
    }
  }
})();